import React, { useEffect, useState } from "react";
import { useDataProvider } from "../../api/DataProvider";
import Typography from "@material-ui/core/Typography";
import "../../styles/devices/mob_SignDialog.css";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { useStyles } from "../../styles/SignDialog";
import RadioGroup, { useRadioGroup } from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import { LinearProgress } from "@material-ui/core";
import { pDataProvider } from "../../utils/parameters";
import SendIcon from "@mui/icons-material/Send";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";

const StyledFormControlLabel = styled((props) => <FormControlLabel {...props} />)(({ theme, checked }) => ({
  ".MuiFormControlLabel-label": checked && {
    color: theme.palette.primary.main,
    fontWeight: 500,
  },
}));

function MyFormControlLabel(props) {
  const radioGroup = useRadioGroup();
  let checked = false;
  if (radioGroup) {
    checked = radioGroup.value === props.value;
  }
  return <StyledFormControlLabel checked={checked} {...props} />;
}

MyFormControlLabel.propTypes = {
  value: PropTypes.any,
};

export default function DialogContentDef(props) {
  const { dialogPosition, setDialogPosition, dialogElements } = props;
  const { json_data_meaning, comm_getPublicURLVideoData } = useDataProvider();
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [definitionNotEmpty, setDefinitionNotEmpty] = useState(false);
  
  const [multiple_meanings, setMultiple_meanings] = useState(false);

  const styles = useStyles();

  const handleChangeRadioButton = (event) => {
    const new_meaning = event.target.value;
    const initial_position_gloss = dialogElements[new_meaning][0];
    setDialogPosition({
      ...dialogPosition,
      meaning: new_meaning,
      gloss: initial_position_gloss,
    });
  };

  function onLoadedDef() {
    setVideoLoaded(true);
  }

  useEffect(() => {
    try{
      setMultiple_meanings(dialogElements[dialogPosition["lemma"]].length > 1);
    }catch(e){
      console.error(e)
    }
  }, [dialogPosition]);

  useEffect(() => {
    console.log("🚀 ~ DEF- DialogContentDef ~ dialogElements:", dialogElements)
    console.log("🚀 ~ DEF- DialogContentDef ~ dialogPosition:", dialogPosition)
    const definition = json_data_meaning[dialogPosition["meaning"]]["definition"];
    console.log("🚀 ~ DEF- DialogContentDef useEffect ~ json_data_meaning[dialogPosition[meaning]][definition]:", definition)
    setDefinitionNotEmpty(typeof definition === 'string' && definition.length > 1);
  }, [dialogPosition, dialogElements]);
    
  
  
  

  return (
    <>
      {definitionNotEmpty ? (
        <>
          <div className="sig_SignModal_VideoContainer">
            {!videoLoaded && <LinearProgress className={styles.videoLoading} color="primary" />}
            <video className={styles.signVideo} autoPlay loop src={comm_getPublicURLVideoData(pDataProvider.dir_vid_definition, dialogPosition["meaning"])} onLoadedData={onLoadedDef} />
          </div>

          <div className="sig_SignModal_Definition">
            {(multiple_meanings == false) ? (
              <Typography className={`sig_SignDialog_TextDefinition ${dialogElements["elements"][1] !== undefined ? "sig_SignDialog_TextDefinitionWithStepper" : ""}`}>{json_data_meaning[dialogPosition["meaning"]]["definition"]}</Typography>
            ) : (
              <RadioGroup name="use-radio-group" defaultValue={dialogPosition["meaning"]} onChange={handleChangeRadioButton}>
                {dialogElements[dialogPosition["lemma"]].map((item, index) => {
                  return <MyFormControlLabel value={item} key={index} label={json_data_meaning[item]["definition"]} control={<Radio />} />;
                })}
              </RadioGroup>
            )}
            {props.children}
          </div>
        </>
        ):(
          <>
                    <Paper className="sig_SignModal_PaperContent">
                      <div className='sig_SignModal_PaperInfo'style={{backgroundColor: '#e78b9b'}}>
                        <div className='sig_SignModal_PaperLine'>
                          <div className="sig_SignModal_PaperTitle"> Sin definición.</div>
                          <div className="sig_SignModal_PaperBody"> Actualmente no disponemos de definiciones para el signo seleccionado. </div>
                        </div>
                      </div> 
                    </Paper>
                  </>
        )
      }
    </>
  );
}

